import { createAction } from 'redux-starter-kit'

export const RESET_ALL_REPORTS = '[reports] reset all reports'

export const resetAllReportsAction = createAction(RESET_ALL_REPORTS)

export const SHARED_REPORTS_LIST_PATH = '/author/reports/shared-reports'

/** Keep in sync with backend sharedReportAccess deny copy (DAT-697). */
export const REPORT_ACCESS_DENIED_MESSAGES = [
  'You do not have access to view this report.',
  'You do not have access to update this report.',
  'You do not have access to delete this report.',
]

export const getReportFetchErrorMessage = (error, fallback) => {
  const message = error?.message
  return message && message !== 'NA' ? message : fallback
}

/**
 * Normalize report API failures for Redux.
 * Prefer keeping HTTP status — @edulastic/api sets `error.status` on boom errors.
 */
export const normalizeReportFetchError = (error, fallback) => ({
  message: getReportFetchErrorMessage(error, fallback),
  status: error?.status || error?.response?.status || error?.statusCode || null,
})

/**
 * Detect shared-report / parent access deny for UI leave-page handling.
 *
 * Prefer HTTP **403** when present: any forbidden response while opening
 * `?reportId=` is an access deny for this flow (view / update / delete / parent).
 *
 * Exact message matching is a **fallback** only — several report filter ducks
 * historically store just the boom `message` string in Redux (status discarded).
 * Matching the known DAT-697 deny strings avoids redirecting on unrelated
 * filter failures (network / 500 / validation) that happen to leave firstLoad stuck.
 */
export const isReportAccessDenied = (errorOrMessage) => {
  if (!errorOrMessage) return false

  const status =
    typeof errorOrMessage === 'object'
      ? errorOrMessage.status ||
        errorOrMessage.statusCode ||
        errorOrMessage.response?.status
      : null
  if (status === 403) return true

  const message =
    typeof errorOrMessage === 'string' ? errorOrMessage : errorOrMessage.message
  if (!message || message === 'NA') return false
  return REPORT_ACCESS_DENIED_MESSAGES.includes(message)
}

/**
 * Clear shared-report first-load spinner and leave the stuck report shell.
 * Call when filter/data fetch fails with reportId in the URL.
 * Sets location state so Shared Reports can refetch the list once.
 */
export const leaveDeniedSharedReport = ({ history, setFirstLoad }) => {
  if (typeof setFirstLoad === 'function') {
    setFirstLoad(false)
  }
  if (history?.replace) {
    history.replace({
      pathname: SHARED_REPORTS_LIST_PATH,
      state: { refreshSharedReports: true },
    })
  }
}
